import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import FullscreenIcon from "@mui/icons-material/OpenInFull";
import CloseIcon from "@mui/icons-material/Close";
import { useDfrTheme } from "./dfrTheme";

export default function DfrMap({ id, buttons, children }) {
    const [isFullscreen, setIsFullscreen] = useState(false);
    const mapWrapperRef = useRef(null);
    const { mode } = useDfrTheme();

    useEffect(() => {
        const handleFullscreen = () => setIsFullscreen(!!document.fullscreenElement);
        document.addEventListener("fullscreenchange", handleFullscreen);
        return () => document.removeEventListener("fullscreenchange", handleFullscreen);
    }, []);

    const handleFullscreen = () => {
        try {
            if (isFullscreen) {
                document.exitFullscreen();
            } else {
                mapWrapperRef.current.requestFullscreen();
            }
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Box id={id} ref={mapWrapperRef} sx={{ width: "100%", height: "100%", position: "relative" }}>
            {children}
            <Box sx={{ position: "absolute", zIndex: 1, right: "8px", top: "8px", display: "flex", flexDirection: "row", gap: "8px" }}>
                {buttons?.map(({ name, icon, onClick }, i) => (
                    <button
                        key={i}
                        type="button"
                        title={name}
                        onClick={onClick}
                        className={mode === "dark" ? "control-button-dark" : "control-button"}
                        style={{ width: "32px", height: "32px" }}
                    >
                        {icon || name}
                    </button>
                ))}
                <button
                    type="button"
                    title={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
                    onClick={handleFullscreen}
                    className={mode === "dark" ? "control-button-dark" : "control-button"}
                    style={{ width: "32px", height: "32px" }}
                >
                    {isFullscreen ? <CloseIcon fontSize="small" /> : <FullscreenIcon fontSize="small" />}
                </button>
            </Box>
        </Box>
    );
}
